import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";
import { Flex } from "@similarweb/ui-components/foundations";

const ONBOARDING_MODAL_BORDER_WIDTH = 0.5;
const ONBOARDING_MODAL_WIDTH = 455;

export const ONBOARDING_INFO_MODAL_STYLES = {
    content: {
        padding: 0,
        borderRadius: 6,
        border: `${ONBOARDING_MODAL_BORDER_WIDTH}px solid rgba(0, 0, 0, 0.00)`,
        backgroundColor: colorsPalettes.carbon[0],
        boxShadow: "0 15px 12px 0 rgba(0, 0, 0, 0.22), 0 19px 38px 0 rgba(0, 0, 0, 0.30)",
        width: `${ONBOARDING_MODAL_WIDTH}px`,
        maxWidth: ONBOARDING_MODAL_WIDTH,
        maxHeight: 600,
        overflow: "hidden",
        outline: "none",
    },
    overlay: {
        backgroundColor: "rgba(67, 89, 147, 0.70)",
    },
};

export const StyledOnboardingInfoPopupHeader = styled.div`
    padding: 20px 24px;
`;

export const StyledOnboardingInfoPopupFooter = styled(Flex)`
    padding: 8px 16px 16px 16px;
`;

export const StyledOnboardingInfoPopupContentWrapper = styled(Flex)`
    padding: 0 24px;
`;

export const StyledOnboardingInfoImage = styled.img`
    width: 208px;
    height: 160px;
`;

export const StyledOnboardingInfoList = styled.ul`
    list-style-type: disc;
    margin-bottom: 0;
`;
